import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthProvider'
import { View, Text, StyleSheet, KeyboardAvoidingView, Platform } from 'react-native';
import { MainColors } from '../../constants/Colors';
import FontSizes from '../../constants/FontSizes';
import MainButton from '../../components/Buttons/MainButton';
import AuthTextInput from './components/AuthTextInput';
import ActivityIndicator from '../../components/ActivityIndicator'

const ForgotPasswordScreen = () => {
    const { forgotPasswordSendEmail, forgotPasswordSetNewPassword, login, isLoading, errorMessage } = useContext(AuthContext)
    const [email, setEmail] = useState('');
    const [showSetPassword, setShowSetPassword] = useState(false)
    const [verificationDetails, setVerificationDetails] = useState({})
    const [verificationCode, setVerificationCode] = useState('');
    const [newPassword, setNewPassword] = useState('')
    
    const onSendEmailPressedHandler = async () => {
        const details = await forgotPasswordSendEmail(email)
        setShowSetPassword(true)
        setVerificationDetails(details)
        console.log(details)
    }

    const onSetNewPasswordPressedHandler = async () => {
        await forgotPasswordSetNewPassword(email, verificationCode, newPassword)
        await login(email, newPassword)
    }

    if(!showSetPassword){
        return (
            <ActivityIndicator isLoading={isLoading}>
                <KeyboardAvoidingView 
                style={styles.screen}
                enabled
                behavior={Platform.OS === "ios" ? "padding" : "height"}
                >
                    <View style={styles.contentContainer}>
                        <Text style={styles.headerText}>
                            Forgot your password?
                        </Text>
                        <View style={styles.headerSubTextContainer}>
                            <Text style={styles.headerSubText}>
                                Enter your email and we'll send you instructions to reset your password.
                            </Text>
                        </View>
                        <AuthTextInput
                            value={email}
                            returnKeyType='done'
                            onChangeText={email => setEmail(email)}
                            placeholder={'Email'}
                            accessibilityLabel="Email"
                            accessibilityHint="Type in your email here"
                            onSubmitEditin={onSendEmailPressedHandler}
                        />
                        <MainButton
                            style={styles.sendBtnText}
                            onPress={onSendEmailPressedHandler}
                            text={'Send'}
                            accessibilityLabel="Send"
                            accessibilityHint="Press this button to send a reset password email"
                        />
                    </View>
                </KeyboardAvoidingView>
            </ActivityIndicator>
        )
    }else{
        return (
            <ActivityIndicator isLoading={isLoading}>
                <View style={styles.screen}>
                    <View style={styles.contentContainer}>
                        <Text style={styles.headerText}>
                            Forgot your password?
                        </Text>
                        <View style={styles.headerSubTextContainer}>
                            <Text style={styles.headerSubText}>
                                An {verificationDetails.AttributeName} has been sent to {verificationDetails.Destination} with a temporary verification code.
                            </Text>
                        </View>
                        <AuthTextInput
                            returnKeyType='done'
                            value={verificationCode}
                            onChangeText={verificationCode => setVerificationCode(verificationCode)}
                            placeholder={'Verification Code'}
                            accessibilityLabel="Verification Code"
                            accessibilityHint="Type your temporary verification code here"
                            onSubmitEditin={onSetNewPasswordPressedHandler}
                        />
                        <AuthTextInput
                            autoCompleteType="password"
                            secureTextEntry={true}
                            returnKeyType='done'
                            value={newPassword}
                            onChangeText={newPassword => setNewPassword(newPassword)}
                            placeholder={'New Password'}
                            accessibilityLabel="New Password"
                            accessibilityHint="Type new password here"
                            onSubmitEditin={onSetNewPasswordPressedHandler}
                        />
                        <MainButton
                            style={styles.sendBtnText}
                            onPress={onSetNewPasswordPressedHandler}
                            text={'Update Password and Login'}
                            accessibilityLabel="Update Password and Login"
                            accessibilityHint="Press this button to set your new password"
                        />
                    </View>
                </View>
            </ActivityIndicator>
        )
    }
}

export const screenOptions = () => {
    return {
        headerTitle: ""
    }
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: 30
    },
    contentContainer: {
        minWidth: 335,
        maxWidth: 420
    },
    headerText: {
        color: MainColors.primary,
        fontSize: FontSizes.extraLarge,
        fontWeight: '500',
        marginBottom: 20,
        textAlign: 'center'
    },
    headerSubTextContainer: {
        flexDirection: 'row'
    },
    headerSubText: {
        flex: 1,
        flexWrap: 'wrap',
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        textAlign: 'center',
        marginBottom: 30
    },
    forgotPasswordContainer: {
        alignSelf: 'flex-end',
        marginTop: -14
    },
    forgotPasswordBtnText: {
        fontSize: FontSizes.small
    },
    sendBtnText: {
        fontSize: FontSizes.medium,
        marginTop: 50
    }
});

export default ForgotPasswordScreen;

